import React, { useEffect } from "react";
import handleScroll from "../../util/handleScroll";
import corner from "../../assets/corner.png";
import cornerTR from "../../assets/cornerTR.png";
import cornerBR from "../../assets/cornerBR.png";
import cornerBL from "../../assets/cornerBL.png";
import vector from "../../assets/cred/vector.png";
import collaborate from "../../assets/cred/collaborate.gif";

const Cred = ({ page }) => {
    return (
        <div className="container-fluid cred-outer-container">
            <div className="container cred-inner-container">
                <div className="row justify-content-evenly">
                    <div className="col-xl-5 col-lg-5 col-md-5 cred-image-col">
                        <div className="img-container">
                            <img
                                src={collaborate}
                                alt=""
                                className="gif-container"
                            />
                        </div>
                    </div>
                    <div
                        className="col-xl-6 col-lg-7 col-md-7 cred-description"
                        onScroll={() => handleScroll(page)}
                    >
                        <div className="cred-scrollable" id="cred-1">
                            <img src={corner} alt="" id="topleft" />
                            <img src={cornerTR} alt="" id="topright" />
                            <img src={cornerBR} alt="" id="bottomright" />
                            <img src={cornerBL} alt="" id="bottomleft" />
                            <div>
                                <p className="strikethrough-text">
                                    zoom fatigue, with boxed video tiles
                                </p>
                                <div className="cred-heading-container">
                                    <p className="cred-heading">
                                        efficient, rewarding collaboration
                                    </p>
                                    <img src={vector} alt="" className="arrow" />
                                </div>
                                <p className="cred-descriptionbox">
                                    spontaneous real-time communication{" "}
                                </p>
                                <button className="tryyourself-cred">
                              try yourself >>>
                                </button>
                            </div>
                        </div>
                        <div className="gutter-height"></div>
                        <div className="cred-scrollable" id="cred-2">
                            <img src={corner} alt="" id="topleft" />
                            <img src={cornerTR} alt="" id="topright" />
                            <img src={cornerBR} alt="" id="bottomright" />
                            <img src={cornerBL} alt="" id="bottomleft" />
                            <div>
                                <p className="strikethrough-text">
                                    broken into asynchronous silos
                                </p>
                                <div className="cred-heading-container">
                                    <p className="cred-heading">
                                        entire commune sits under one roof
                                    </p>
                                    <img src={vector} alt="" className="arrow" />
                                </div>
                                <p className="cred-descriptionbox">
                                    build a strong culture with shared experiences
                                </p>
                                <button className="tryyourself-cred">
                              try yourself >>>
                                </button>
                            </div>
                        </div>
                        <div className="gutter-height"></div>
                        <div className="cred-scrollable" id="cred-3">
                            <img src={corner} alt="" id="topleft" />
                            <img src={cornerTR} alt="" id="topright" />
                            <img src={cornerBR} alt="" id="bottomright" />
                            <img src={cornerBL} alt="" id="bottomleft" />
                            <div>
                                <p className="strikethrough-text">
                                    lack of effective engagement
                                </p>
                                <div className="cred-heading-container">
                                    <p className="cred-heading">
                                        mimic real-like social dynamics
                                    </p>
                                    <img src={vector} alt="" className="arrow" />
                                </div>
                                <p className="cred-descriptionbox">
                                    real-like engagement & networking experience
                                </p>
                                <button className="tryyourself-cred">
                              try yourself >>>
                                </button>
                            </div>
                        </div>
                        <div className="gutter-height"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cred;